
import { qualityService } from "@/service";
import { getTitle } from "@/utils/util";
import { defineComponent, reactive, ref } from "vue";
interface PageData {
  list: Array<any>;
  loading: boolean;
  finished: boolean;
  page: number;
}
export default defineComponent({
  setup() {
    const searchForm = reactive({
      target_type: {
        value: "",
        option: [
          { text: "全部", value: "0" },
          { text: "人员", value: "1" },
          { text: "机构", value: "2" }
        ]
      },
      recheck_type: {
        value: "",
        option: [
          { text: "全部", value: "0" },
          { text: "首检", value: "1" },
          { text: "复检", value: "2" }
        ]
      },
      state: {
        value: "",
        option: [
          { text: "全部", value: "0" },
          { text: "进行中", value: "1" },
          { text: "整改中", value: "2" },
          { text: "未完成", value: "7" },
          { text: "完成-合格", value: "8" },
          { text: "完成-不合格", value: "9" }
        ]
      },
      search_name: ""
    });
    const pageList = ref([]);
    const pageData = reactive<PageData>({
      list: [],
      loading: false,
      finished: false,
      page: 1
    });
    const onLoad = async () => {
      try {
        const { data } = await qualityService.pool_lists({
          from: 4,
          target_type: searchForm.target_type.value,
          recheck_type: searchForm.recheck_type.value,
          state: searchForm.state.value,
          search_name: searchForm.search_name,
          page: pageData.page
        });
        pageData.list.push(...data.data);
        pageData.loading = false;
        pageData.finished = false;
        pageData.page++;
        if (pageData.list.length >= data.total) {
          pageData.finished = true;
        }
      } catch (error) {
        pageData.list = [];
        pageData.finished = true;
      }
    };

    const onSearch = () => {
      pageData.list = [];
      pageData.page = 1;
      onLoad();
    };

    const onChange = () => {
      pageData.list = [];
      pageData.page = 1;
      onLoad();
    };

    onLoad();

    return {
      pageList,
      pageData,
      searchForm,
      onLoad,
      getTitle,
      onSearch,
      onChange
    };
  }
});
